"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushSubscriptionServiceFactory = exports.probePushCapabilities = void 0;
var API_BASE = '/api/v2/notifications';
var VAPID_KEY_ENDPOINT = "".concat(API_BASE, "/vapid-public-key");
var SUBSCRIPTION_ENDPOINT = "".concat(API_BASE, "/subscriptions");
var TEST_ENDPOINT = "".concat(API_BASE, "/send-test");
var SERVICE_WORKER_PATH = '/sw.js';
var SERVICE_WORKER_SCOPE = '/';
var OPT_IN_KEY = 'audroam.push.optIn';
/**
 * Probe Web Push capability.
 *
 * IMPORTANT: PushManager is a constructor on **window** (and on
 * ServiceWorkerRegistration.prototype), NOT on navigator.
 * Checking `'PushManager' in navigator` is a false negative on Edge/Chrome.
 */
function probePushCapabilities(win) {
    var _a, _b, _c, _d, _e;
    var w = win;
    var nav = w.navigator;
    var blockers = [];
    var notes = [];
    var secureContext = typeof w.isSecureContext === 'boolean'
        ? !!w.isSecureContext
        : ((_a = w.location) === null || _a === void 0 ? void 0 : _a.protocol) === 'https:' ||
            ((_b = w.location) === null || _b === void 0 ? void 0 : _b.hostname) === 'localhost' ||
            ((_c = w.location) === null || _c === void 0 ? void 0 : _c.hostname) === '127.0.0.1';
    var hasNavigator = typeof nav !== 'undefined';
    var hasServiceWorker = !!(hasNavigator && 'serviceWorker' in nav);
    // Correct global: window.PushManager (Chromium / Edge Android / Firefox)
    var hasWindowPushManager = typeof w.PushManager !== 'undefined';
    // Also accept prototype hook (some environments)
    var hasRegistrationPushManager = typeof w.ServiceWorkerRegistration !== 'undefined' &&
        !!w.ServiceWorkerRegistration.prototype &&
        'pushManager' in w.ServiceWorkerRegistration.prototype;
    var hasNotification = typeof w.Notification !== 'undefined';
    var notificationPermission = 'missing';
    if (hasNotification) {
        try {
            notificationPermission = w.Notification.permission;
        }
        catch (_f) {
            notificationPermission = 'missing';
        }
    }
    var protocol = ((_d = w.location) === null || _d === void 0 ? void 0 : _d.protocol) || '';
    var host = ((_e = w.location) === null || _e === void 0 ? void 0 : _e.host) || '';
    var userAgent = (hasNavigator && nav.userAgent) || '';
    if (!secureContext) {
        blockers.push('Not a secure context (need HTTPS or localhost)');
    }
    if (!hasServiceWorker) {
        blockers.push('navigator.serviceWorker missing');
    }
    if (!hasWindowPushManager && !hasRegistrationPushManager) {
        blockers.push('PushManager missing on window / ServiceWorkerRegistration');
    }
    if (!hasNotification) {
        blockers.push('window.Notification missing');
    }
    if (notificationPermission === 'denied') {
        blockers.push('Notification permission is denied — reset in Edge site settings');
    }
    // Edge Android / Chromium: Web Push works with SW + PushManager + Notification + secure
    var webPushLikely = secureContext &&
        hasServiceWorker &&
        (hasWindowPushManager || hasRegistrationPushManager) &&
        hasNotification;
    if (webPushLikely && notificationPermission === 'default') {
        notes.push('Permission not asked yet — use Enable (user gesture required on mobile)');
    }
    if (webPushLikely && notificationPermission === 'granted') {
        notes.push('Permission already granted — Enable should subscribe + save to server');
    }
    if (/EdgA\//i.test(userAgent) || (/Android/i.test(userAgent) && /Edg\//i.test(userAgent))) {
        notes.push('Edge Android detected — Web Push is supported when site is HTTPS and not an in-app WebView');
    }
    if (!webPushLikely && hasNotification && !hasServiceWorker) {
        notes.push('Local Notification API may work without Service Worker, but server-driven Web Push needs SW + PushManager');
    }
    return {
        secureContext: secureContext,
        hasNavigator: hasNavigator,
        hasServiceWorker: hasServiceWorker,
        hasWindowPushManager: hasWindowPushManager,
        hasRegistrationPushManager: hasRegistrationPushManager,
        hasNotification: hasNotification,
        notificationPermission: notificationPermission,
        protocol: protocol,
        host: host,
        userAgent: userAgent.slice(0, 180),
        webPushLikely: webPushLikely,
        blockers: blockers,
        notes: notes,
    };
}
exports.probePushCapabilities = probePushCapabilities;
var urlBase64ToUint8Array = function (base64String) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; i += 1) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
};
var PushSubscriptionServiceImpl = /** @class */ (function () {
    function PushSubscriptionServiceImpl($http, $q, $window, notificationService) {
        this.$http = $http;
        this.$q = $q;
        this.$window = $window;
        this.notificationService = notificationService;
    }
    PushSubscriptionServiceImpl.prototype.isSupported = function () {
        return this.probeCapabilities().webPushLikely;
    };
    PushSubscriptionServiceImpl.prototype.probeCapabilities = function () {
        return probePushCapabilities(this.$window);
    };
    PushSubscriptionServiceImpl.prototype.getOptIn = function () {
        try {
            return this.$window.localStorage.getItem(OPT_IN_KEY) === '1';
        }
        catch (_a) {
            return false;
        }
    };
    PushSubscriptionServiceImpl.prototype.setOptIn = function (enabled) {
        try {
            if (enabled) {
                this.$window.localStorage.setItem(OPT_IN_KEY, '1');
            }
            else {
                this.$window.localStorage.removeItem(OPT_IN_KEY);
            }
        }
        catch (_a) {
            /* ignore */
        }
    };
    PushSubscriptionServiceImpl.prototype.getStatus = function () {
        return this.$q.when(this.getStatusInternal());
    };
    PushSubscriptionServiceImpl.prototype.getStatusInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var diagnostics, permission, hasBrowserSubscription, reg, sub, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        diagnostics = this.probeCapabilities();
                        if (!diagnostics.webPushLikely) {
                            return [2 /*return*/, {
                                    supported: false,
                                    permission: diagnostics.notificationPermission === 'missing'
                                        ? 'unsupported'
                                        : diagnostics.notificationPermission,
                                    optIn: this.getOptIn(),
                                    hasBrowserSubscription: false,
                                    diagnostics: diagnostics,
                                }];
                        }
                        permission = diagnostics.notificationPermission;
                        hasBrowserSubscription = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.$window.navigator.serviceWorker.getRegistration(SERVICE_WORKER_SCOPE)];
                    case 2:
                        reg = _a.sent();
                        if (!(reg && reg.pushManager)) return [3 /*break*/, 4];
                        return [4 /*yield*/, reg.pushManager.getSubscription()];
                    case 3:
                        sub = _a.sent();
                        hasBrowserSubscription = !!sub;
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        diagnostics.notes.push('getRegistration/getSubscription failed: ' + String(e_1));
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, {
                            supported: true,
                            permission: permission,
                            optIn: this.getOptIn(),
                            hasBrowserSubscription: hasBrowserSubscription,
                            diagnostics: diagnostics,
                        }];
                }
            });
        });
    };
    PushSubscriptionServiceImpl.prototype.initialize = function (options) {
        return this.$q.when(this.initializeInternal(options));
    };
    PushSubscriptionServiceImpl.prototype.initializeInternal = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var diagnostics, reason, permission, err_1, msg, registration, err_2, msg, vapidKey, err_3, msg, existing, e_2, subscription, err_4, msg, err_5, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        diagnostics = this.probeCapabilities();
                        if (!diagnostics.webPushLikely) {
                            reason = diagnostics.blockers.join('; ') || 'web-push-unlikely';
                            this.invokeFallback(options, reason);
                            return [2 /*return*/, {
                                    supported: false,
                                    subscribed: false,
                                    reason: 'unsupported',
                                    permission: diagnostics.notificationPermission,
                                    diagnostics: diagnostics,
                                }];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.ensurePermission(!!(options === null || options === void 0 ? void 0 : options.requestPermission))];
                    case 2:
                        permission = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        msg = err_1 instanceof Error ? err_1.message : String(err_1);
                        this.invokeFallback(options, 'Permission request failed: ' + msg);
                        return [2 /*return*/, {
                                supported: true,
                                subscribed: false,
                                reason: 'permission-error',
                                permission: diagnostics.notificationPermission,
                                diagnostics: diagnostics,
                            }];
                    case 4:
                        if (permission !== 'granted') {
                            this.invokeFallback(options, permission === 'denied'
                                ? 'Permission denied — Edge: lock icon / site settings → Notifications → Allow for this site'
                                : 'Permission not granted yet');
                            return [2 /*return*/, {
                                    supported: true,
                                    subscribed: false,
                                    reason: permission === 'denied' ? 'permission-denied' : 'permission-default',
                                    permission: permission,
                                    diagnostics: diagnostics,
                                }];
                        }
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.registerServiceWorker()];
                    case 6:
                        registration = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        msg = err_2 instanceof Error ? err_2.message : String(err_2);
                        this.invokeFallback(options, 'Service worker register failed: ' + msg);
                        return [2 /*return*/, {
                                supported: true,
                                subscribed: false,
                                reason: 'sw-register-failed',
                                permission: permission,
                                diagnostics: diagnostics,
                            }];
                    case 8:
                        if (!registration.pushManager) {
                            this.invokeFallback(options, 'ServiceWorkerRegistration has no pushManager (unexpected on Edge Android HTTPS)');
                            return [2 /*return*/, {
                                    supported: false,
                                    subscribed: false,
                                    reason: 'no-push-manager-on-registration',
                                    permission: permission,
                                    diagnostics: diagnostics,
                                }];
                        }
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, this.fetchVapidPublicKey()];
                    case 10:
                        vapidKey = _a.sent();
                        return [3 /*break*/, 12];
                    case 11:
                        err_3 = _a.sent();
                        msg = err_3 instanceof Error ? err_3.message : 'VAPID key unavailable';
                        this.invokeFallback(options, msg);
                        return [2 /*return*/, {
                                supported: true,
                                subscribed: false,
                                reason: 'vapid-unavailable',
                                permission: permission,
                                diagnostics: diagnostics,
                            }];
                    case 12:
                        if (!(options === null || options === void 0 ? void 0 : options.forceResubscribe)) return [3 /*break*/, 18];
                        _a.label = 13;
                    case 13:
                        _a.trys.push([13, 17, , 18]);
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 14:
                        existing = _a.sent();
                        if (!existing) return [3 /*break*/, 16];
                        return [4 /*yield*/, existing.unsubscribe()];
                    case 15:
                        _a.sent();
                        _a.label = 16;
                    case 16: return [3 /*break*/, 18];
                    case 17:
                        e_2 = _a.sent();
                        console.warn('[push] unsubscribe before resubscribe failed', e_2);
                        return [3 /*break*/, 18];
                    case 18:
                        subscription = null;
                        _a.label = 19;
                    case 19:
                        _a.trys.push([19, 21, , 22]);
                        return [4 /*yield*/, this.ensureSubscription(registration, vapidKey)];
                    case 20:
                        subscription = _a.sent();
                        return [3 /*break*/, 22];
                    case 21:
                        err_4 = _a.sent();
                        msg = err_4 instanceof Error ? err_4.message : String(err_4);
                        this.invokeFallback(options, 'subscribe() failed: ' + msg);
                        return [2 /*return*/, {
                                supported: true,
                                subscribed: false,
                                reason: 'subscribe-threw',
                                permission: permission,
                                diagnostics: diagnostics,
                            }];
                    case 22:
                        if (!subscription) {
                            this.invokeFallback(options, 'Push subscription not available after subscribe()');
                            return [2 /*return*/, {
                                    supported: true,
                                    subscribed: false,
                                    reason: 'subscription-failed',
                                    permission: permission,
                                    diagnostics: diagnostics,
                                }];
                        }
                        _a.label = 23;
                    case 23:
                        _a.trys.push([23, 25, , 26]);
                        return [4 /*yield*/, this.saveSubscription(subscription)];
                    case 24:
                        _a.sent();
                        return [3 /*break*/, 26];
                    case 25:
                        err_5 = _a.sent();
                        msg = err_5 instanceof Error ? err_5.message : 'Failed to save subscription';
                        this.invokeFallback(options, msg);
                        return [2 /*return*/, {
                                supported: true,
                                subscribed: false,
                                reason: 'save-failed',
                                permission: permission,
                                diagnostics: diagnostics,
                            }];
                    case 26:
                        this.setOptIn(true);
                        return [2 /*return*/, { supported: true, subscribed: true, permission: permission, diagnostics: diagnostics }];
                }
            });
        });
    };
    PushSubscriptionServiceImpl.prototype.sendTest = function (message) {
        var _this = this;
        return this.$http
            .post(TEST_ENDPOINT, {
            message: message || 'Audroam push test — if you see this, Web Push is working.',
            url: '/',
        })
            .then(function (response) { return response.data; })
            .catch(function (err) {
            var error = (err && err.data && (err.data.error || err.data.Message)) ||
                (err && err.status === 0 ? 'Network error' : 'Send test failed');
            return _this.$q.reject(new Error(String(error)));
        });
    };
    PushSubscriptionServiceImpl.prototype.getPrefs = function () {
        return this.$http
            .get("".concat(API_BASE, "/prefs"))
            .then(function (r) { return (r.data && r.data.prefs) || {}; });
    };
    PushSubscriptionServiceImpl.prototype.savePrefs = function (prefs) {
        return this.$http
            .put("".concat(API_BASE, "/prefs"), prefs)
            .then(function (r) { return (r.data && r.data.prefs) || prefs; });
    };
    PushSubscriptionServiceImpl.prototype.runTick = function (opts) {
        return this.$http.post("".concat(API_BASE, "/tick"), opts || { force: false }).then(function (r) { return r.data; });
    };
    PushSubscriptionServiceImpl.prototype.sendStartOfDayNow = function () {
        return this.$http.post("".concat(API_BASE, "/send-start-of-day"), {}).then(function (r) { return r.data; });
    };
    PushSubscriptionServiceImpl.prototype.sendDueScheduleNow = function () {
        return this.$http.post("".concat(API_BASE, "/send-due-schedule"), {}).then(function (r) { return r.data; });
    };
    PushSubscriptionServiceImpl.prototype.sendLongOpenNow = function () {
        return this.$http.post("".concat(API_BASE, "/send-long-open"), {}).then(function (r) { return r.data; });
    };
    PushSubscriptionServiceImpl.prototype.getPendingSummary = function () {
        return this.$http
            .get("".concat(API_BASE, "/pending-summary"))
            .then(function (r) { return (r.data && r.data.summary) || {}; });
    };
    PushSubscriptionServiceImpl.prototype.invokeFallback = function (options, reason) {
        if (options && typeof options.onFallback === 'function') {
            options.onFallback('Push notifications unavailable', reason);
        }
        console.warn('[push]', reason);
    };
    /**
     * Mobile browsers require a user gesture for Notification.requestPermission().
     * Prefer modern promise-returning API; fall back to callback form.
     */
    PushSubscriptionServiceImpl.prototype.ensurePermission = function (requestIfNeeded) {
        return __awaiter(this, void 0, void 0, function () {
            var NotificationCtor, current, viaService, _a, result, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        NotificationCtor = this.$window.Notification;
                        if (!NotificationCtor) {
                            return [2 /*return*/, 'denied'];
                        }
                        current = NotificationCtor.permission;
                        if (current === 'granted' || current === 'denied') {
                            return [2 /*return*/, current];
                        }
                        if (!requestIfNeeded) {
                            return [2 /*return*/, current];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.notificationService.requestPermission()];
                    case 2:
                        viaService = _b.sent();
                        if (viaService === 'granted' || viaService === 'denied' || viaService === 'default') {
                            return [2 /*return*/, viaService];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        _b.trys.push([4, 8, , 9]);
                        result = NotificationCtor.requestPermission();
                        if (!(result && typeof result.then === 'function')) return [3 /*break*/, 6];
                        return [4 /*yield*/, result];
                    case 5: return [2 /*return*/, (_b.sent())];
                    case 6: return [4 /*yield*/, new Promise(function (resolve) {
                            NotificationCtor.requestPermission(function (perm) { return resolve(perm); });
                        })];
                    case 7: 
                    // Legacy callback form
                    return [2 /*return*/, _b.sent()];
                    case 8:
                        error_1 = _b.sent();
                        console.warn('[push] requestPermission failed:', error_1);
                        return [2 /*return*/, NotificationCtor.permission || 'denied'];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    PushSubscriptionServiceImpl.prototype.registerServiceWorker = function () {
        return __awaiter(this, void 0, void 0, function () {
            var existing, _a, _b, registration, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.$window.navigator.serviceWorker.getRegistration(SERVICE_WORKER_SCOPE)];
                    case 1:
                        existing = _e.sent();
                        if (!existing) return [3 /*break*/, 9];
                        _e.label = 2;
                    case 2:
                        _e.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, existing.update()];
                    case 3:
                        _e.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _e.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        _e.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.$window.navigator.serviceWorker.ready];
                    case 6:
                        _e.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        _b = _e.sent();
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/, existing];
                    case 9: return [4 /*yield*/, this.$window.navigator.serviceWorker.register(SERVICE_WORKER_PATH, {
                            scope: SERVICE_WORKER_SCOPE,
                        })];
                    case 10:
                        registration = _e.sent();
                        _e.label = 11;
                    case 11:
                        _e.trys.push([11, 13, , 14]);
                        return [4 /*yield*/, this.$window.navigator.serviceWorker.ready];
                    case 12:
                        _e.sent();
                        return [3 /*break*/, 14];
                    case 13:
                        _c = _e.sent();
                        return [3 /*break*/, 14];
                    case 14:
                        _e.trys.push([14, 16, , 17]);
                        return [4 /*yield*/, registration.update()];
                    case 15:
                        _e.sent();
                        return [3 /*break*/, 17];
                    case 16:
                        _d = _e.sent();
                        return [3 /*break*/, 17];
                    case 17: return [2 /*return*/, registration];
                }
            });
        });
    };
    PushSubscriptionServiceImpl.prototype.fetchVapidPublicKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err, hint, e_3, data, err, hint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$http.get(VAPID_KEY_ENDPOINT)];
                    case 1:
                        response = _a.sent();
                        if (!response.data || !response.data.publicKey) {
                            err = (response.data && response.data.error) || 'Missing VAPID public key';
                            hint = response.data && response.data.hint ? ' — ' + response.data.hint : '';
                            throw new Error(err + hint);
                        }
                        return [2 /*return*/, response.data.publicKey];
                    case 2:
                        e_3 = _a.sent();
                        if (e_3 && e_3.message && /VAPID|vapid/i.test(e_3.message)) {
                            throw e_3;
                        }
                        data = e_3 && e_3.data;
                        err = (data && data.error) ||
                            (e_3 && e_3.status === 500
                                ? 'VAPID not configured on server (500 from /vapid-public-key)'
                                : e_3 && e_3.status === 401
                                    ? 'Not authenticated — log in before enabling push'
                                    : 'VAPID key request failed');
                        hint = data && data.hint ? ' — ' + data.hint : '';
                        throw new Error(String(err) + hint);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PushSubscriptionServiceImpl.prototype.ensureSubscription = function (registration, vapidPublicKey) {
        return __awaiter(this, void 0, void 0, function () {
            var existing, applicationServerKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 1:
                        existing = _a.sent();
                        if (existing) {
                            return [2 /*return*/, existing];
                        }
                        applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);
                        // Edge/Chrome accept BufferSource; cast for TS lib variance
                        return [2 /*return*/, registration.pushManager.subscribe({
                                userVisibleOnly: true,
                                applicationServerKey: applicationServerKey,
                            })];
                }
            });
        });
    };
    PushSubscriptionServiceImpl.prototype.saveSubscription = function (subscription) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$http.post(SUBSCRIPTION_ENDPOINT, {
                            subscription: subscription.toJSON(),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PushSubscriptionServiceImpl;
}());
exports.pushSubscriptionServiceFactory = [
    '$http',
    '$q',
    '$window',
    'notificationService',
    function ($http, $q, $window, notificationService) {
        return new PushSubscriptionServiceImpl($http, $q, $window, notificationService);
    },
];
